import LogoImage from "@src/app/assets/logo@2x.svg";
import MainContainer from "@src/app/components/Layouts/MainContainer/MainContainer";
import NewsletterWidget from "@src/app/components/Modules/NewsletterPage/NewsletterWidget/NewsletterWidget";
import cx from "classnames";
import type { ReactElement } from "react";

import Copyright from "./Copyright";
import styles from "./Footer.module.css";
import FooterInfo from "./FooterInfo";
import FooterLinks from "./FooterLinks";
import PoweredBy from "./PoweredBy";
import SocialLinks from "./SocialLinks";

export default function Footer(): ReactElement {
  return (
    <footer className={styles.footer}>
      <div className={styles.footerTop}>
        <MainContainer>
          <div className={styles.footerTopContent}>
            <div className={styles.footerLogo}>
              <a href="/" aria-label="Go to ThinkChina Home">
                <img
                  src={LogoImage}
                  className={cx(styles.logo, "lazyload")}
                  alt="ThinkChina logo"
                  width="510"
                  height="154"
                  loading="lazy"
                />
              </a>
            </div>
            <SocialLinks />
          </div>
        </MainContainer>
      </div>
      <div className={styles.footerCenter}>
        <MainContainer>
          <div className={styles.footerCenterRow}>
            <FooterInfo />
            {/* Newsletter Widget */}
            <NewsletterWidget
              headerTitle={"Get the ThinkChina weekly newsletter"}
              bodyText={
                "Insights on China, right in your mailbox. Sign up now."
              }
              icon={""}
            />
          </div>
        </MainContainer>
      </div>
      <div className={styles.footerDivider}></div>
      <div className={styles.copyrightContainer}>
        <MainContainer>
          <PoweredBy />
          <div className={styles.copyrightContent}>
            <Copyright />
            <FooterLinks />
          </div>
        </MainContainer>
      </div>
    </footer>
  );
}
